module.exports = __webpack_public_path__ + "img/113ne.ac038933.svg";